import { Box, ColorOptions, ModBox, Spacer } from '@jfs/ui-new'
import { SvgImage } from '../../comps/SvgImage'
import { MerchantDetail } from './MerchantDetail'
import { styles } from './style'

export const QrHeader = ({ merchantName, vpa }: any) => {
  return (
    <ModBox alignItems={'center'} justify="space-between" pt={20}>
      <Box alignItems={'center'} justify="center" height={110}>
        <Box {...styles.ripple1(110)} zIndex={1} position={'absolute'} />
        <Box {...styles.ripple2(150)} zIndex={1} position={'absolute'} />
        <Box
          zIndex={10}
          backgroundColor={'PRIMARY' as ColorOptions}
          width={70}
          height={70}
          borderRadius={70}
          justifyContent="center"
          alignItems={'center'}>
          <SvgImage imageName="store" color={'#fff'} />
        </Box>
      </Box>
      <ModBox zIndex={15}>
        <Spacer size={40} direction="vertical" />
        <MerchantDetail merchantName={merchantName} vpa={vpa} color={'#fff'} />
      </ModBox>
    </ModBox>
  )
}

// export const style = {
//   ripple1: {
//     backgroundColor: 'PRIMARY',
//     opacity: 0.3,
//     width: 100,
//     height: 100,
//     borderRadius: 100,
//     position: 'absolute',
//   } as BoxProps,
//   ripple2: {
//     backgroundColor: 'PRIMARY',
//     opacity: 0.2,
//     width: 130,
//     height: 130,
//     borderRadius: 130,
//     position: 'absolute',
//   } as BoxProps,
// }
